import EditContactModal from './EditContactModal';

export default EditContactModal;
